import React from 'react';
import PropTypes from 'prop-types';
import {GelDragDropContext, useGelDragDrop} from './GelDragDrop.utils';
import {THEME} from './GelDragDrop.constants';
import {Title} from './Title';
import {Table} from './Table';
import './style.scss';

export function GelDragDrop(props) {
  const setTheme = () => {
    if (props.theme === THEME.DARK) return '';
    else return props.theme.toLowerCase();
  };

  React.useEffect(() => {
    props.setHeadingAriaLabel ? props.setHeadingAriaLabel() : null;
  }, []);

  return (
    <GelDragDropContext.Provider value={useGelDragDrop(props)}>
      <div className={`${setTheme()} gelDragDrop`} style={props.style}>
        <Title title={props.title} />
        <Table
          table={props.gelTable}
          headingAriaLabel={props.headingAriaLabel}
        />
      </div>
    </GelDragDropContext.Provider>
  );
}

GelDragDrop.propTypes = {
  /**
   * Title instruction to show on top of gel table
   */
  title: PropTypes.string,
  /**
   * High/Low values of Gel Table Ladders
   */
  gelRange: PropTypes.shape({
    /**
     * The lowest Ladder value
     */
    bottom: PropTypes.number,
    /**
     * The highest Ladder value
     */
    top: PropTypes.number,
  }),
  /**
   * Data for gel table
   */
  gelTable: PropTypes.arrayOf(PropTypes.object),
  /**
   *  Function to invoke on Gel position update
   */
  onGelUpdate: PropTypes.func,
  /**
   * Function to invoke when a Gel band is clicked to select it
   */
  onGelSelect: PropTypes.func,
  /**
   * Style object to set on application wrapper
   */
  style: PropTypes.object,
  /**
   * Theme for the component
   */
  theme: PropTypes.oneOf(['LIGHT', 'DARK']),
  /**
   * AriaLabel of the heading
   */
  headingAriaLabel: PropTypes.shape({
    /**
     * Unique key for the data
     */
    key: PropTypes.number,
    /**
     * Label of the Heading
     */
    label: PropTypes.string,
    /**
     * Arialabel to display on the heading
     */
    ariaLabel: PropTypes.string,
  }),
  /**
   * FUnction used to generate ariaLabel
   * onloading the component
   */
  setHeadingAriaLabel: PropTypes.func,
};

GelDragDrop.defaultProps = {
  style: {},
  theme: THEME.DARK,
};
